var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5703",
    "data-name": "Group 5703",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2638",
    "data-name": "Rectangle 2638",
    width: 30,
    height: 30,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5654",
    "data-name": "Group 5654",
    transform: "translate(4.958 4.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M26.727,23.963a1.959,1.959,0,1,1-2.771,2.771L17.029,19.8,10.1,26.732a1.959,1.959,0,0,1-2.771-2.771l6.926-6.927L7.33,10.106A1.959,1.959,0,1,1,10.1,7.335l6.927,6.927,6.927-6.927a1.959,1.959,0,0,1,2.771,2.771L19.8,17.033Z",
    transform: "translate(-6.756 -6.76)",
    fill: "#92979c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2dc0c3e194c49fe78cb90494bf055f74.svg";
export { ForwardRef as ReactComponent };